export default __webpack_public_path__ + "static/guarantors-e455a60c42ace3889aa3e11dd238d4e0.png";